import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BuyerProductCardComponent } from '@tix/event-buyer/components';
import { FrontofficeWrapperComponent } from './frontoffice-wrapper/frontoffice-wrapper.component';
import { TixOrderSummaryPage } from './order-summary/order-summary.component';
import { TixPaymentSuccessPage } from './payment-success/payment-success.component';
import { VenueIdResolver } from './venue-id.resolver';
import { VenuePortalComponent } from './venue-portal/venue-portal.component';
import { VenueSlugResolver } from './venue-slug.resolver';
import { TixEventCalendarViewFrontComponent } from './event-calendar-view-front/event-calendar-view-front.component';

const routes: Routes = [
  {
    path: '',
    component: FrontofficeWrapperComponent,
    children: [
      {
        path: 'venue/:id',
        pathMatch: 'full',
        component: VenuePortalComponent,
        resolve: { venueId: VenueIdResolver }
      },
      {
        path: 'venue/:venueId/addons/:eventId',
        pathMatch: 'full',
        component: BuyerProductCardComponent
      },
      {
        path: 'checkout/:id',
        pathMatch: '',
        component: TixOrderSummaryPage
      },
      {
        path: 'success/:id/:reservationId',
        pathMatch: 'full',
        component: TixPaymentSuccessPage
      },
      // TEMP DISABLE UNTIL FIX CALENDER VIEW ISSUE
      {
        path: 'venue/:venueId/calendar-view',
        pathMatch: 'full',
        component: TixEventCalendarViewFrontComponent
      },
      {
        path: ':venueSlug/calendar-view',
        pathMatch: 'full',
        component: TixEventCalendarViewFrontComponent,
        resolve: { venueId: VenueSlugResolver }
      },
      {
        path: ':venueSlug',
        //pathMatch: 'full',
        component: VenuePortalComponent,
        children: [
          {
            path: ':event-keyword',
            pathMatch: 'full',
            component: VenuePortalComponent
          }
        ],
        resolve: { venueId: VenueSlugResolver }
      }
      // {
      //   path: '',
      //   pathMatch: 'full',
      //   component: TixEventBuyerPage
      // }
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EventBuyerRoutingModule {}
